<template>
  <div class="chart-container">
    <canvas ref="doughnutChart"></canvas>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement);

export default {
  name: "DoughnutChart",
  props: {
    // Propiedad 'title' completamente eliminada
    chartData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
      }),
    },
  },
  setup(props) {
    const doughnutChart = ref(null);

    onMounted(() => {
      new ChartJS(doughnutChart.value, {
        type: "doughnut",
        data: props.chartData,
        options: props.chartOptions,
      });
    });

    return { doughnutChart };
  },
};
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 300px; /* Ajusta la altura según lo necesites */
}
</style>